import { Component, input, output, computed } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'outline' | 'ghost' | 'ghost-danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

/**
 * Botón estandarizado del design system.
 *
 * El contenido se proyecta, así que admite:
 *  - solo texto:        <app-button>Guardar</app-button>
 *  - icono + texto:     <app-button><lucide-icon [img]="plus"/> Agregar</app-button>
 *  - solo icono:        <app-button [iconOnly]="true" ariaLabel="Editar"><lucide-icon [img]="pencil"/></app-button>
 *
 * La acción se expone vía (buttonClick); funciona con cualquier handler
 * (abrir modal, submit, ref de plantilla como fileInput.click(), etc.).
 */
@Component({
  selector: 'app-button',
  standalone: true,
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  host: {
    '[class.btn-host--full]': 'fullWidth()',
  },
})
export class ButtonComponent {
  /** type nativo del <button> */
  type = input<'button' | 'submit' | 'reset'>('button');
  variant = input<ButtonVariant>('primary');
  size = input<ButtonSize>('md');
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
  /** botón cuadrado solo-icono (acciones de tabla) */
  iconOnly = input<boolean>(false);
  /** ocupa todo el ancho disponible */
  fullWidth = input<boolean>(false);
  /** permite que el texto se parta en varias líneas (útil en contenedores angostos) */
  wrap = input<boolean>(false);
  /** sin sombra/elevación (útil dentro de tarjetas pequeñas) */
  flat = input<boolean>(false);
  /** accesibilidad: obligatorio en botones solo-icono */
  ariaLabel = input<string | null>(null);

  buttonClick = output<void>();

  readonly isDisabled = computed(() => this.disabled() || this.loading());

  onClick(): void {
    if (!this.isDisabled()) {
      this.buttonClick.emit();
    }
  }
}
